import { SidebarExpandedIcon } from '@repo/studio-design-system-ui-icons/layout/sidebar-expanded'
import { SidebarCollapsedIcon } from '@repo/studio-design-system-ui-icons/layout/sidebar-collapsed'
import { Button } from '@repo/studio-design-system-ui-button'

export function ToggleSidebarButton({
  onClick,
  openOrExpanded,
}: {
  onClick: () => void
  openOrExpanded: boolean
}) {
  const Icon = openOrExpanded ? SidebarExpandedIcon : SidebarCollapsedIcon

  return (
    <Button
      iconOnly
      size="xs"
      variant="ghost"
      onClick={onClick}
      className="ml-1 md:ml-[10px]"
      aria-label="Toggle sidebar"
      aria-expanded={openOrExpanded}
    >
      <Icon aria-hidden="true" />
    </Button>
  )
}
